module.exports = "<div class=\"d-flex\">\n  <input type=\"checkbox\"\n    [checked]=\"record.selected\">\n</div>\n";